import PasswordStrengthValidator from './elements_jquery/password_strength_validator';
import TranslationLoader from "./utilities/translation_loader";

// public javascript
const $ = require('jquery');

$(function(){

  $("body").on("input propertychange", ".form-group", function(e) {
    $(this).toggleClass("floating-value", !!$(e.target).val());
  }).on("focus", ".form-group", function() {
    $(this).addClass("floating-focus");
  }).on("blur", ".form-group", function() {
    $(this).removeClass("floating-focus");
  });

  window.setInterval(function(){
    $('.form-group:not(.form-group-floating)').each(function(){
      $(this).toggleClass("floating-value", !!$(this).find('input,select,textarea').val());
      $(this).addClass('form-group-floating');
    });
  }, 500);

  function togglePasswordView(el) {
    var formGroup = $(el).parents('.form-group');
    var input = formGroup.find('input');

    if (input.attr('type') == 'password') {
      formGroup.addClass('password-revealed');
      input.attr('type', 'text');
    } else {
      formGroup.removeClass('password-revealed');
      input.attr('type', 'password');
    }

    $(el).filter('button').attr('aria-pressed', input.attr('type') === 'text');
  }

  $("body").on('click', '.toggle-password-view', function(e){
    togglePasswordView(e.currentTarget);

    const targetSel = $(e.currentTarget).attr('data-toggle-password');
    if(targetSel) {
      const targetEl = $(targetSel);
      if(targetEl && targetEl.length > 0) {
          togglePasswordView(targetEl[0]);
      }
    }
  });

  // login tabs (twingle account / Microsoft / ELKB-Ident)
  function activateLoginTab(tab) {
    $('[data-login-tab]').each(function() {
      const active = this === tab;
      $(this).toggleClass('active', active).attr({'aria-selected': active, 'tabindex': active ? 0 : -1});
      $('#' + $(this).attr('aria-controls')).prop('hidden', !active);
    });
  }

  // the login service chosen last is preselected on the next visit
  const loginTabStorageKey = 'tw-login-tab';

  function rememberLoginTab(tab) {
    try {
      localStorage.setItem(loginTabStorageKey, $(tab).data('login-tab'));
    } catch (e) {
      // storage not available, the twingle tab stays the default
    }
  }

  try {
    const lastLoginTab = $('[data-login-tab="' + localStorage.getItem(loginTabStorageKey) + '"]');
    if (lastLoginTab.length) {
      activateLoginTab(lastLoginTab[0]);
    }
  } catch (e) {
    // storage not available, the twingle tab stays the default
  }

  $("body").on('click', '[data-login-tab]', function(e) {
    activateLoginTab(e.currentTarget);
    rememberLoginTab(e.currentTarget);
  }).on('keydown', '[data-login-tab]', function(e) {
    const tabs = $('[data-login-tab]');
    const current = tabs.index(e.currentTarget);
    const targets = {
      ArrowLeft: (current - 1 + tabs.length) % tabs.length,
      ArrowRight: (current + 1) % tabs.length,
      Home: 0,
      End: tabs.length - 1
    };
    const next = targets[e.key];
    if (next === undefined) return;

    e.preventDefault();
    activateLoginTab(tabs[next]);
    rememberLoginTab(tabs[next]);
    tabs[next].focus();
  });

  TranslationLoader.loadTranslation(Laravel.lang).then(() => {
    PasswordStrengthValidator.init();
  });

})
